import { useEffect, useState } from "react";
import { _Inbox, _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP006 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_UBLInvoice);
    const [props, setProps] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(bean.observations)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }
        toast.success("Orden de pago publicada.");
    }

    const postSupplierPaymentOrderToSupervisor = () => {
        instance.postSupplierPaymentOrderToSupervisor(props.IDSupplierPaymentOrder, props.SupplierPaymentOrderDate, bean.observations, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp);
                onExportMap();
            }
        ).catch(err => toast.error(err));

    }

    return (
        <div className="row">
            <div className="col-md-12 mt-2">
                <label>Observaciones</label>
                <textarea name="Description" className="form-control" rows={5} value={bean.observations} onChange={(e) => { setBean({ ...bean, "observations": e.target.value }) }} />
            </div>
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={() => {
                    if (bean.observations.length > 15) {
                        postSupplierPaymentOrderToSupervisor()
                    } else {
                        toast.error("La observacion debe tener minimo 15 caracteres")
                    }
                }} icon="ri-send-plane-line" >Enviar</BasicButton>
            </div>
        </div>

    )
}